import { useEffect, useState } from "react";

// API
import { GetPublicAuthors } from "../../Api/PublicAuthors";

// Models
import PublicAuthorDTO from "../../Models/DTOs/PublicAuthorDTO";

const useFetchPublicAuthors = () => {
    const [authors, setAuthors] = useState<PublicAuthorDTO[]>([]);
    const [authorsLoading, setAuthorsLoading] = useState(true);
    const [authorsError, setAuthorsError] = useState("");

    useEffect(() => {
        const abortController = new AbortController();
        let isCancelled = false;

        setAuthorsLoading(true);
        setAuthorsError("");

        (async () => {
            try {
                const response = await GetPublicAuthors(abortController);

                if (!isCancelled) {
                    setAuthors(Array.isArray(response.items) ? response.items : []);
                }
            } catch (_error) {
                if (!isCancelled) {
                    setAuthors([]);
                    setAuthorsError("Presenters are unavailable right now.");
                }
            } finally {
                if (!isCancelled) {
                    setAuthorsLoading(false);
                }
            }
        })();

        return () => {
            isCancelled = true;
            abortController.abort();
        };
    }, []);

    return { authors, authorsLoading, authorsError };
};

export default useFetchPublicAuthors;
